import * as apiUtility from '../../config/APIUtils';
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

const BASE_URL_EMAIL_TO_EMPLOYER = "user/sendEmailEmp";
const BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED = "course/getAllCourseVersion_forUser";

/***
 * 
 * @param {{}} [userData={}] 
 * @param {{}} [policyData={}] 
 * @param {{}} [courseData={}] 
 * @param {{}} [trainingProviders={}] 
 * @param {string} [reportName=''] 
 * @param {string} [fileName=''] 
 * @param {boolean} [isEmail=false]
 * @param {string} [reportType=1]  
 * 
 */
export async function PolicyExcelReport(userData = {}, policyData = {}, courseData={}, trainingProviders={}, reportName = '', fileName = '', isEmail = false, reportType=1) {
    let responseBody = {};
    try {
            
        let rowsCount = 6;
        let newRowCount = 6;
        const title = [{ A: 'Care Passport - '+reportName }];
        let userTable = [{ A: 'Name', B: 'User ID', C: 'Date Of Birth', D: 'Date', E: 'Home', F: 'Role' }];

        userTable.push({
                A: userData.firstName + " " + userData.lastName,
                B: userData.user_id,
                C: userData.dob,
                D: new Date().toLocaleString(),
                E: userData.homeName,
                F: userData.roleName
            });

        userTable.push("");
        userTable.push("");

        if(reportType === 0 || reportType === 2){
            let courseVersionHeader = {
                A: 'Course Code', B: 'Course Title', C: 'Description', D: 'Training Provider', E: 'Course Status', F: 'Expiry Date'
            };
                    
            userTable.push(courseVersionHeader);
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED;
            apiRequest.data = {
                "courses": courseData,
                "userId": userData.user_id
            };
            await apiUtility.sendAPIDataPOST(apiRequest).then(response => {
                for (let item of response.data) {
                    rowsCount += 1;
                    var courseVersion = {};
                    courseVersion = {
                        A: item.crsId,
                        B: item.parentTitle,
                        C: item.desc,//mapOfTpIdName[parseInt(item.orgIssued)],
                        D: (trainingProviders !== undefined) ? trainingProviders[parseInt(item.orgIssued)] : '', 
                        E: item.equivalentCrsStatus,
                        F: item.validity
                    };
                    userTable.push(courseVersion);
                }
            }).catch(error => {
                return responseBody = {code : 500, message: "Error while processing courses."}
            });
            
            userTable.push("");
            userTable.push("");

            rowsCount = (reportType === 2) ? rowsCount+2 : rowsCount;
            newRowCount = rowsCount;
        }

        if(reportType === 1 || reportType === 2){
            let policyHeader = { A: 'Doc Code', B: 'Title', C: 'Description', D: 'Review Status', E: 'Expiry Date', F: 'Expiry Reason'};
            userTable.push(policyHeader);
            
                for (let item of policyData) {
                    rowsCount += 1;
                    let policyRow = {};

                    policyRow = {
                        A: item.policyId,
                        B: item.title,
                        C: (item.description === undefined) ? "" : item.description,
                        //D: (item.completion_date !== "") ? new Date(item.completion_date).toLocaleDateString() : "",
                        D: (item.status !== "Pending") ? item.status : "",
                        E: (item.expiry_date !== "") ? new Date(item.expiry_date).toLocaleDateString() : "",
                        F: (item.expiry_reason !== "") ? item.expiry_reason : "",
                    };
                    userTable.push(policyRow);
                    
                }
        }
        
        const finalData = [...title, ...userTable];
        const worksheet = XLSX.utils.json_to_sheet(finalData, {
            skipHeader: true,
        });
        const workbook = XLSX.utils.book_new();
        let sheetName = (reportType === 1) ? '_PolicyReport' : '_Training&PolicyReport'
        XLSX.utils.book_append_sheet(workbook, worksheet, userData.user_id + sheetName);
        const workbookblob = workbook2blob(workbook);
        var headerIndexes = [];
        finalData.forEach((data, index) => 
            (data["A"] === "Course Code" || data["A"] === "Doc Code") ? headerIndexes.push(index) : null
        );
        let headRange = (reportType === 0 || reportType === 2) ? `A${headerIndexes[0] + 1}:F${headerIndexes[0] + 1}` : `A${headerIndexes[0] + 1}:F${headerIndexes[0] + 1}`;
        const dataInfo = {
            titleCell: "A2",
            titleRange: "A1:F1",
            uHeadRange: `A2:F2`,
            uBodyRange: `A3:F3`,
            tbodyRange: `A7:F${finalData.length}`,
            theadRange:
                headerIndexes?.length >= 1  
                    ? headRange
                    : null,
            tFirstColumnRange:
                headerIndexes?.length >= 1
                    ? `A${headerIndexes[0] + 1}:A${rowsCount + headerIndexes[0] + 1}`
                    : null,
            tLastColumnRange:
                headerIndexes?.length >= 1
                    ? `D${headerIndexes[0] + 1}:E${rowsCount + headerIndexes[0] + 1}`
                    : null,
            
            bheadRange:
                headerIndexes?.length >= 1
                    ? `A${newRowCount + 1}:F${newRowCount + 1}`
                    : null,
            bFirstColumnRange:
                headerIndexes?.length >= 1
                    ? `A${headerIndexes[1] + 1}:A${newRowCount + headerIndexes[1] + 1}`
                    : null,
            bLastColumnRange:
                headerIndexes?.length >= 1
                    ? `D${headerIndexes[1] + 1}:E${newRowCount + headerIndexes[1] + 1}`
                    : null,

        };


        XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
            workbook.sheets().forEach((sheet) => {
                sheet.column("A").width(15);
                sheet.column("B").width(45);
                sheet.column("C").width(45);
                sheet.column("D").width(30);
                sheet.column("E").width(30);
                sheet.column("F").width(30);
                sheet.column("G").width(30);
                
                sheet.range(dataInfo.titleRange).merged(true).style({
                    bold: true,
                    fontFamily: "Arial",
                    horizontalAlignment: "center",
                    verticalAlignment: "center",
                });
                sheet.range(dataInfo.uHeadRange).style({
                    fill: "A6A6A6",
                    bold: true,
                    horizontalAlignment: "center",
                });
                sheet.range(dataInfo.uBodyRange).style({
                    bold: true,
                    horizontalAlignment: "center",
                });
                if (dataInfo.tbodyRange) {
                    sheet.range(dataInfo.tbodyRange).style({
                        horizontalAlignment: "left",
                    });
                }
                sheet.range(dataInfo.theadRange).style({
                    fill: "A6A6A6",
                    bold: true,
                    horizontalAlignment: "center",
                });
                if (dataInfo.tFirstColumnRange) {
                    sheet.range(dataInfo.tFirstColumnRange).style({
                        bold: true,
                    });
                }
                if (dataInfo.tLastColumnRange) {
                    sheet.range(dataInfo.tLastColumnRange).style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                }

                if(reportType === 2){
                    sheet.range(dataInfo.bheadRange).style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });
                    if (dataInfo.bFirstColumnRange) {
                        sheet.range(dataInfo.bFirstColumnRange).style({
                            bold: true,
                        });
                    }
                    if (dataInfo.bLastColumnRange) {
                        sheet.range(dataInfo.bLastColumnRange).style({
                            bold: true,
                            horizontalAlignment: "center",
                        });
                    }
                }
            });

            return workbook.outputAsync().then((workbookBlob) => {
                if (isEmail) {
                    var data = new FormData();
                    data.append("userId", userData.user_id);
                    data.append("emailId", userData.empEmailId);
                    data.append("file", workbookBlob);
                    data.append("subject", "Carepassport - "+reportName);
                    data.append("reportName", fileName);
                    data.append("type", "Excel");
                    let apiRequest = apiUtility.apiInputRequest;
                    apiRequest.endPoint = BASE_URL_EMAIL_TO_EMPLOYER;
                    apiRequest.data = data;
                    apiUtility.sendAPIDataPOST(apiRequest)
                        .then(response => {
                            responseBody = {code : 200, message: response.data}
                        }).catch(error => {
                            responseBody = {code : 500, message: "Error while sending email"}
                        });
                    
                    return responseBody;
                } else {
                    const downloadAnchorNode = document.createElement("a");
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName !== '' ? fileName + ".xlsx" : "Carepassport_" + userData.user_id + ".xlsx" );
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                    
                    return responseBody = {code : 200, message: 'File downloaded successfully'}
                }

            });
        });
    
    } catch (error) {
        console.log("error : ", error);        
        return responseBody = {code:200 , message: error};
    }

}

const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }